<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-tools text-white"></i></div>
        <div>
          Machine Types
          <div class="page-title-subheading">Machine Type Master and Downtime Reasons.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="mb-3 card">
        <div class="card-header d-flex justify-content-between align-items-center">
          Machine Types
          <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#machineTypeModal" (click)="openAddModal()">
            <i class="fa fa-plus mr-1"></i> Add Machine Type
          </button>
        </div>
        <div class="card-body">
          <div *ngIf="loading" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
          </div>
          <vio-table-v2 *ngIf="!loading" [tableData]="tableData" [tableConfig]="tableConfig"></vio-table-v2>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Machine Type modal -->
  <div class="modal fade" id="machineTypeModal" tabindex="-1" aria-hidden="true" appAppendToBody>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ operation === 'Add' ? 'Add Machine Type' : 'Edit Machine Type' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="required">Machine Type</label>
            <input class="form-control" placeholder="Machine Type" [(ngModel)]="machineTypeForm.name" />
          </div>
          <div class="form-group">
            <label>Description</label>
            <input class="form-control" placeholder="Description" [(ngModel)]="machineTypeForm.description" />
          </div>
          <!-- Downtime reasons — managed inline. In Add mode there's no machine type _id yet, so
          reasons are staged locally and sent along with the initial create() call; in Edit mode
          each add/remove hits the API immediately. -->
          <ng-container *ngIf="operation === 'Add'">
            <div class="downtime-reasons-section">
              <div class="downtime-reasons-heading">
                <i class="fa fa-tags mr-1"></i>
                Downtime Reasons
                <span class="badge badge-pill downtime-count-badge ml-1">{{ newMachineTypeReasons.length }}</span>
              </div>

              <div class="reason-add-row mb-3">
                <i class="fa fa-plus-circle reason-add-icon"></i>
                <input
                  class="form-control reason-add-input"
                  placeholder="Reason name"
                  [(ngModel)]="newReasonName"
                  (keyup.enter)="addStagedReason()"
                />
                <button class="btn btn-primary reason-add-btn" type="button" (click)="addStagedReason()">Add</button>
              </div>

              <ul class="reason-list mb-0" *ngIf="newMachineTypeReasons.length">
                <li class="reason-item" *ngFor="let reason of newMachineTypeReasons; let i = index">
                  <span>{{ reason }}</span>
                  <button class="btn btn-sm btn-outline-danger" (click)="removeStagedReason(i)" aria-label="Remove reason">
                    <i class="fa fa-trash-alt"></i>
                  </button>
                </li>
              </ul>
              <div class="reason-empty-state mb-0" *ngIf="!newMachineTypeReasons.length">
                <i class="fa fa-clipboard-list"></i>
                <span>No downtime reasons yet — add one above.</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="operation === 'Edit' && editingMachineType as machineType">
            <div class="downtime-reasons-section">
              <div class="downtime-reasons-heading">
                <i class="fa fa-tags mr-1"></i>
                Downtime Reasons
                <span class="badge badge-pill downtime-count-badge ml-1">{{ machineType.downtimeReasons.length }}</span>
              </div>

              <div class="reason-add-row mb-3">
                <i class="fa fa-plus-circle reason-add-icon"></i>
                <input class="form-control reason-add-input" placeholder="Reason name" [(ngModel)]="newReasonName" (keyup.enter)="addReason()" />
                <button class="btn btn-primary reason-add-btn" type="button" (click)="addReason()">Add</button>
              </div>

              <ul class="reason-list mb-0" *ngIf="machineType.downtimeReasons.length">
                <li class="reason-item" *ngFor="let reason of machineType.downtimeReasons">
                  <span>{{ reason.name }}</span>
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteReason(reason)" aria-label="Remove reason">
                    <i class="fa fa-trash-alt"></i>
                  </button>
                </li>
              </ul>
              <div class="reason-empty-state mb-0" *ngIf="!machineType.downtimeReasons.length">
                <i class="fa fa-clipboard-list"></i>
                <span>No downtime reasons yet — add one above.</span>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #machineTypeModalCloseBtn>Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveMachineType()">
            <i class="fa" [class.fa-plus]="operation === 'Add'" [class.fa-check]="operation === 'Edit'"></i>
            {{ operation === 'Add' ? 'Add Machine Type' : 'Save Changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
